import { SiglasFilter } from './../models/siglas-filter';
import { Injectable } from '@angular/core';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';

const defaultSortParam = 'descripcio';
const defaultSortDirection = 'asc';

@Injectable()
export class SiglasFilterService extends CustomFilterService {
  public createFilterParams(filter: SiglasFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('id', filter.id)
    .append('descripcio', filter.descripcio)
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
